import React, { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { HOLDER_STATUS_VERIFY_EMAIL, HolderService, HOLDER_STATUS_NOT_ENTITLED } from './services/holder.service';
import { getHomepath, getConfigs } from './util/cms-utils';
import { useLocation } from 'react-router-dom';

const Verify = ({ holderHost }: { holderHost: string }) => {
  const { authState } = useOktaAuth()
  const holderService = new HolderService(authState, holderHost);
  const query = new URLSearchParams(useLocation().search);
  const config = getConfigs(query.get('clubCode'));

  useEffect(() => {
    const getHolder = async (): Promise<void> => {
      try {
        const holder = await holderService.getValidationStatus(config.clubCode, config.venueId);
        if (!holder || !holder.accountId) {
          window.parent.location.href = `${getHomepath(config)}/message/not-entitled`;
          return;
        }
      } catch (_error) {
        const error = _error as Error
        if (error.message === HOLDER_STATUS_VERIFY_EMAIL) {
          // app show email verify button
          window.parent.location.href = `${getHomepath(config)}/app`;
        } else if (error.message === HOLDER_STATUS_NOT_ENTITLED) {
          window.parent.location.href = `${getHomepath(config)}/message/not-entitled`;
        }
        console.error('error getting holder on misc page', error);
      }
    }
    getHolder();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ /* on did mount */]);

  return (
    <span />
  );

};

export default Verify;
